// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__lFbej","imageUploader":"EGiftCard_imageUploader__2WzWd"};